export const FILTERS_BLOCK_HEIGHT = 542;
